import { render } from "./WNrestartRecordListCY.vue?vue&type=template&id=4797fc13&scoped=true"
import script from "./WNrestartRecordListCY.vue?vue&type=script&lang=js"
export * from "./WNrestartRecordListCY.vue?vue&type=script&lang=js"

import "./WNrestartRecordListCY.vue?vue&type=style&index=0&id=4797fc13&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4797fc13"

export default script